import type { OptionsProps } from '@/components/atoms/select/Select';

const issuingBodies: OptionsProps[] = [
  { value: 'abnc', label: 'ABNC: Academia Brasileira de Neurocirurgia' },
  {
    value: 'cgpi',
    label: 'CGPI: Coordenação-Geral de Privilégios e Imunidades',
  },
  {
    value: 'cgpmaf',
    label:
      'CGPMAF: Coordenadoria Geral de Polícia Marítima, Aeronáutica e de Fronteiras',
  },
  { value: 'civil_registry', label: 'Cartório Civil' },
  { value: 'cnig', label: 'CNIG: Conselho Nacional de Imigração' },
  { value: 'cnt', label: 'CNT: Confederação Nacional de Transporte' },
  { value: 'coren', label: 'COREN: Conselho Regional de Enfermagem' },
  { value: 'corecon', label: 'CORECON: Conselho Regional de Economia' },
  { value: 'cra', label: 'CRA: Conselho Regional de Administração' },
  {
    value: 'cras',
    label: 'CRAS: Centro de Referência de Assistência Social',
  },
  { value: 'crb', label: 'CRB: Conselho Regional de Biblioteconomia' },
  { value: 'crc', label: 'CRC: Conselho Regional de Contabilidade' },
  { value: 'cre', label: 'CRE: Conselho Regional de Estatística' },
  {
    value: 'crea',
    label: 'CREA: Conselho Regional de Engenharia e Agronomia',
  },
  {
    value: 'creci',
    label: 'CRECI: Conselho Regional de Corretores de Imóveis',
  },
  {
    value: 'crefit',
    label: 'CREFIT: Conselho Regional de Fisioterapia e Terapia Ocupacional',
  },
  { value: 'cress', label: 'CRESS: Conselho Regional de Serviço Social' },
  { value: 'crf', label: 'CRF: Conselho Regional de Farmácia' },
  { value: 'crm', label: 'CRM: Conselho Regional de Medicina' },
  { value: 'crn', label: 'CRN: Conselho Regional de Nutrição' },
  { value: 'cro', label: 'CRO: Conselho Regional de Odontologia' },
  { value: 'crp', label: 'CRP: Conselho Regional de Psicologia' },
  {
    value: 'crpre',
    label: 'CRPRE: Conselho Regional de Profissionais de Relações Públicas',
  },
  { value: 'crq', label: 'CRQ: Conselho Regional de Química' },
  {
    value: 'crrc',
    label: 'CRRC: Conselho Regional de Representantes Comerciais',
  },
  {
    value: 'crmv',
    label: 'CRMV: Conselho Regional de Medicina Veterinária',
  },
  { value: 'csc', label: 'CSC: Carteira Sede Carpina de Pernambuco' },
  {
    value: 'ctps',
    label: 'CTPS: Carteira de Trabalho e Previdência Social',
  },
  {
    value: 'detran',
    label: 'DETRAN: Emissão de CNH (Carteira Nacional de Habilitação)',
  },
  { value: 'dic', label: 'DIC: Diretoria de Identificação Civil' },
  { value: 'direx', label: 'DIREX: Diretoria-Executiva' },
  { value: 'dpf', label: 'DPF: Departamento de Polícia Federal' },
  {
    value: 'dpmaf',
    label: 'DPMAF: Divisão de Polícia Marítima, Área e de Fronteiras',
  },
  { value: 'dpt', label: 'DPT: Departamento de Polícia Técnica Geral' },
  { value: 'dst', label: 'DST: Programa Municipal DST/Aids' },
  {
    value: 'durex',
    label:
      'DUREX: Coordenação Geral de Polícia de Imigração da Polícia Federal',
  },
  { value: 'est', label: 'EST: Carteira de Estrangeiro' },
  { value: 'fgts', label: 'FGTS: Fundo de Garantia do Tempo de Serviço' },
  {
    value: 'fipe',
    label: 'FIPE: Fundação Instituto de Pesquisas Econômicas',
  },
  { value: 'fls', label: 'FLS: Fundação Lyndolpho Silva' },
  { value: 'gov', label: 'GOV: Governo do Estado de Goiás' },
  { value: 'icla', label: 'ICLA: Carteira de Identidade Classista' },
  { value: 'ifp', label: 'IFP: Instituto Félix Pacheco' },
  { value: 'igp', label: 'IGP: Instituto Geral de Perícias' },
  {
    value: 'iiccecf',
    label:
      'IICCECF: Instituto de Identificação Civil e Criminal Engrácia da Costa Francisco de Rondônia',
  },
  { value: 'iimg', label: 'IIMG: Inter-institutional Monitoring Group' },
  { value: 'iml', label: 'IML: Instituto Médico-Legal' },
  { value: 'ipc', label: 'IPC: Índice de Preços ao Consumidor' },
  { value: 'ipf', label: 'IPF: Instituto Pereira Faustino' },
  { value: 'mae', label: 'MAE: Ministério da Aeronáutica' },
  { value: 'mex', label: 'MEX: Ministério do Exército' },
  { value: 'mma', label: 'MMA: Ministério da Marinha' },
  { value: 'oab', label: 'OAB: Ordem dos Advogados do Brasil' },
  { value: 'omb', label: 'OMB: Ordens dos Músicos do Brasil' },
  { value: 'pc', label: 'PC: Polícia Civil' },
  { value: 'pm', label: 'PM: Polícia Militar do Estado' },
  { value: 'pof', label: 'POF: Polícia Federal' },
  { value: 'pom', label: 'POM: Polícia Militar' },
  { value: 'sds', label: 'SDS: Secretaria de Defesa Social (Pernambuco)' },
  {
    value: 'snj',
    label: 'SNJ: Secretaria Nacional de Justiça / Departamento de Estrangeiros',
  },
  { value: 'secc', label: 'SECC: Secretaria de Estado da Casa Civil' },
  {
    value: 'sejusp',
    label:
      'SEJUSP: Secretaria de Estado de Justiça e Segurança Pública – Mato Grosso',
  },
  { value: 'ses', label: 'SES: Carteira de Estrangeiro' },
  {
    value: 'sesp',
    label: 'SESP: Secretaria de Estado da Segurança Pública do Paraná',
  },
  { value: 'sjs', label: 'SJS: Secretaria da Justiça e Segurança' },
  {
    value: 'sjtc',
    label: 'SJTC: Secretaria da Justiça do Trabalho e Cidadania',
  },
  {
    value: 'sjts',
    label: 'SJTS: Secretaria da Justiça do Trabalho e Segurança',
  },
  {
    value: 'sptc',
    label: 'SPTC: Secretaria de Polícia Técnico-Científica',
  },
  { value: 'ssds', label: 'SSDS: Secretaria da Segurança e da Defesa Social' },
  { value: 'ssp', label: 'SSP: Secretaria de Estado da Segurança Pública' },
];

export default issuingBodies;
